import styled, { keyframes } from 'styled-components';

// Animação de flutuação suave (levitação)
const float = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
  100% {
    transform: translateY(0px);
  }
`;

export const LoaderContainer = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  background-image: url('/ufo.png');
  background-size: contain;
  background-repeat: no-repeat;
  animation: ${float} 2s ease-in-out infinite;
`;
